let i18nInstance;
export const getI18nInstance = () => {
    return i18nInstance;
};
